// extracted by mini-css-extract-plugin
export default {"action":"styles_action__5VEzy","btn2":"styles_btn2__4h0iy","btn1":"styles_btn1__5feXT"};